import SociosDeNegocioInfoStore from './SociosDeNegocioInfoStore';
import SociosDeNegocioListStore from './SociosDeNegocioListStore';
import SociosDeNegocioUpsertStore from './SociosDeNegocioUpsertStore';

const SociosDeNegocioStore = {
  info: SociosDeNegocioInfoStore,
  list: SociosDeNegocioListStore,
  upsert: SociosDeNegocioUpsertStore,
};

export default SociosDeNegocioStore;
